import React from 'react';
import { Button } from './ui/button';
import { ChevronDown, Phone } from 'lucide-react';

export const Hero = () => {
  const scrollToMenu = () => {
    const menuSection = document.querySelector('#menu');
    if (menuSection) {
      menuSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.querySelector('#contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Hero Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1625813506062-0aeb1d7a094b"
          alt="Artisan burger and pizza"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 gradient-hero" />
      </div>

      {/* Hero Content */}
      <div className="container mx-auto px-4 sm:px-6 relative z-10 text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-background/10 backdrop-blur-sm border border-background/20 text-background">
            <span className="text-sm font-medium">Depuis 2015</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-bold text-background leading-tight">
            Pizza &
            <br />
            <span className="text-secondary">Gourmandises</span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl md:text-2xl text-background/90 max-w-2xl mx-auto leading-relaxed">
            Burgers artisanaux & pizzas authentiques préparés avec passion à Landerneau
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button
              onClick={scrollToMenu}
              size="lg"
              className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-strong hover:shadow-glow transition-all text-base sm:text-lg px-8 py-6"
            >
              Découvrir la Carte
            </Button>
            <Button
              onClick={scrollToContact}
              size="lg"
              variant="outline"
              className="bg-background/10 backdrop-blur-sm border-background/30 text-background hover:bg-background/20 hover:border-background/40 transition-all text-base sm:text-lg px-8 py-6"
            >
              <Phone className="w-5 h-5 mr-2" />
              Commander
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 pt-12 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-background">100%</div>
              <div className="text-sm sm:text-base text-background/80 mt-1">Fait Maison</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-background">🇫🇷</div>
              <div className="text-sm sm:text-base text-background/80 mt-1">Bœuf & Poulet Origine France</div>
            </div>
            <div className="text-center">
              <div className="text-3xl sm:text-4xl font-bold text-background">9+</div>
              <div className="text-sm sm:text-base text-background/80 mt-1">Années d'Excellence</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToMenu}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce"
        aria-label="Scroll to menu"
      >
        <ChevronDown className="w-8 h-8 text-background" />
      </button>
    </section>
  );
};

export default Hero;